module.exports = __webpack_public_path__ + "img/javascript.e73667c4.png";